// extracted by mini-css-extract-plugin
module.exports = {"modelBox":"modelBox___2AmMg","modelHeader":"modelHeader___3grD5","searchBox":"searchBox___2In00","tableBox":"tableBox___2XbKL","operation":"operation___3C3cq","bgc":"bgc___2eEvF"};